import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { SiteLocale } from '../types'

export function useSiteLocale() {
  const { locale } = useI18n()
  const currentLocale = computed(() => locale.value as SiteLocale)
  const toggleLocale = () => {
    locale.value = currentLocale.value === 'zh-CN' ? 'en-US' : 'zh-CN'
    document.documentElement.lang = locale.value
  }
  return { locale, currentLocale, toggleLocale }
}
